const LOCAL_STORAGE_SCHEMA_VERSION_KEY = 'localStorageSchemaVersion'
const LOCAL_STORAGE_SCHEMA_VERSION_LATEST = 1

const normalizeCoinTopupPlansStorage = () => {
  const coinTopupStorageRaw = localStorage.getItem('coinTopupPlansStorage')
  const coinStorageRaw = localStorage.getItem('coinUserStorage')
  let topupPlans: any[] = []

  if (coinTopupStorageRaw) {
    try {
      const parsed = JSON.parse(coinTopupStorageRaw) as Record<string, any>
      if (Array.isArray(parsed.topupPlans)) {
        topupPlans = parsed.topupPlans
      } else {
        const firstBucket = Object.values(parsed).find((item) =>
          Array.isArray((item as Record<string, any>)?.topupPlans)
        )
        const firstBucketTopupPlans = (firstBucket as Record<string, any> | undefined)?.topupPlans
        if (Array.isArray(firstBucketTopupPlans)) {
          topupPlans = firstBucketTopupPlans
        }
      }
    } catch {}
  }

  if (topupPlans.length === 0 && coinStorageRaw) {
    try {
      const parsed = JSON.parse(coinStorageRaw) as Record<string, any>
      const firstBucket = Object.values(parsed).find((item) => Array.isArray((item as Record<string, any>)?.topupPlans))
      const firstBucketTopupPlans = (firstBucket as Record<string, any> | undefined)?.topupPlans
      if (Array.isArray(firstBucketTopupPlans)) {
        topupPlans = firstBucketTopupPlans
      }
    } catch {}
  }

  localStorage.setItem('coinTopupPlansStorage', JSON.stringify({ topupPlans }))
}

const migrateToV1 = () => {
  localStorage.removeItem('WreathStyleCache')
  localStorage.removeItem('CoupletStyleCache')
  localStorage.removeItem('albumFolders')

  const coinStorageRaw = localStorage.getItem('coinUserStorage')
  if (coinStorageRaw) {
    const coinStorageParsed = JSON.parse(coinStorageRaw) as Record<string, any>
    const migratedCoinStorage: Record<string, { coin: number }> = {}
    Object.entries(coinStorageParsed).forEach(([userHandle, storageValue]) => {
      const value = (storageValue || {}) as Record<string, any>
      migratedCoinStorage[userHandle] = { coin: Number(value.coin) || 0 }
    })
    localStorage.setItem('coinUserStorage', JSON.stringify(migratedCoinStorage))
  }

  normalizeCoinTopupPlansStorage()

  const musicStorageRaw = localStorage.getItem('music')
  if (musicStorageRaw) {
    const musicStorageParsed = JSON.parse(musicStorageRaw) as Record<string, any>
    const migratedMusicStorage: Record<string, Record<string, true>> = {}
    Object.entries(musicStorageParsed).forEach(([userHandle, storageValue]) => {
      const musicMap = (storageValue || {}) as Record<string, any>
      const compactMusicMap: Record<string, true> = {}
      Object.entries(musicMap).forEach(([serviceId, enabled]) => {
        if (enabled === true) {
          compactMusicMap[serviceId] = true
        }
      })
      migratedMusicStorage[userHandle] = compactMusicMap
    })
    localStorage.setItem('music', JSON.stringify(migratedMusicStorage))
  }
}

export const runLocalStorageMigrations = () => {
  let currentVersion = Number(localStorage.getItem(LOCAL_STORAGE_SCHEMA_VERSION_KEY) || '0')
  console.log('!debug!', currentVersion)
  if (currentVersion == 1) {
    normalizeCoinTopupPlansStorage()
    console.log('!debug!1')
  }

  if (currentVersion < 1) {
    console.log('!debug!3')

    migrateToV1()
    localStorage.setItem(LOCAL_STORAGE_SCHEMA_VERSION_KEY, String(1))
    currentVersion = 1
  }
  console.log('!debug!2', currentVersion < 2)

  if (currentVersion < 2) {
    console.log('!debug!3')

    localStorage.removeItem('sf-dialog-last-show-date')
    localStorage.setItem(LOCAL_STORAGE_SCHEMA_VERSION_KEY, String(2))
    currentVersion = 2
  }

  normalizeCoinTopupPlansStorage()
}
